import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Page = styled.div`
  width: min(1920px, 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

const Component = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  padding: 160px 20px 150px;

  @media (max-width: 800px) {
    padding: 200px 20px 100px;
  }
`;

const Content = styled.div`
  max-width: 1172px;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #023265;
  font-family: Montserrat, serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;

  & h1 {
    color: #f4b141;
    font-size: 56px;
    font-weight: 600;
    line-height: normal;
    margin: 0 0 40px;

    @media (max-width: 1230px) {
      font-size: 46px;
    }

    @media (max-width: 800px) {
      font-size: 32px;
    }
  }

  & h3 {
    font-size: 22px;
    font-weight: 600;
    margin: 48px 0 16px;
  }

  & p {
    margin: 0 0 16px;
  }

  & ul {
    margin: 0 0 16px;
    padding-left: 24px;
  }

  & li {
    margin-bottom: 12px;
  }

  & hr {
    border: none;
    border-top: 2px solid rgba(2, 50, 101, 0.3);
    margin: 40px 0;
  }
`;

const Status = styled.div`
  color: #023265;
  font-family: Montserrat, serif;
  font-size: 18px;
`;

function PublicOfferPage() {
  const [markdown, setMarkdown] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/public-offer.md`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load offer: ${response.status}`);
        }
        return response.text();
      })
      .then(setMarkdown)
      .catch((err) => {
        console.error(err);
        setError(true);
      });
  }, []);

  return (
    <Page>
      <Header lightVersion />
      <Component>
        <Content>
          {error && <Status>Не вдалося завантажити публічну оферту.</Status>}
          {!error && !markdown && <Status>Завантаження...</Status>}
          {markdown && <ReactMarkdown>{markdown}</ReactMarkdown>}
        </Content>
      </Component>
      <Footer />
    </Page>
  );
}

export default PublicOfferPage;
